import { reactive } from 'vue'

type ToastType = 'success' | 'error' | 'warning' | 'info'

interface ToastItem {
  id: number
  message: string
  type: ToastType
  duration: number
}

const state = reactive<{ toasts: ToastItem[] }>({
  toasts: [],
})

let seed = 0

function show(message: string, type: ToastType = 'info', duration = 3000) {
  const id = ++seed
  state.toasts.push({ id, message, type, duration })
  if (duration > 0) {
    setTimeout(() => remove(id), duration)
  }
}

function remove(id: number) {
  const idx = state.toasts.findIndex((t) => t.id === id)
  if (idx > -1) {
    state.toasts.splice(idx, 1)
  }
}

export function useToast() {
  return {
    toasts: state.toasts,
    show,
    success: (message: string, duration?: number) => show(message, 'success', duration),
    error: (message: string, duration?: number) => show(message, 'error', duration),
    warning: (message: string, duration?: number) => show(message, 'warning', duration),
    info: (message: string, duration?: number) => show(message, 'info', duration),
    remove,
  }
}
